module.exports = __webpack_public_path__ + "static/img/mould3.470cc97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexEditor/mould/mould3.png
// module id = NlRW
// module chunks = 3